import React from 'react'
import './nav.css'
import {FcHome} from 'react-icons/fc'
import {MdContactPhone} from 'react-icons/md'
import {FcSelfServiceKiosk} from 'react-icons/fc'
import {SiAboutdotme} from 'react-icons/si'
import {MdLibraryBooks} from 'react-icons/md'
import {MdFolderSpecial} from 'react-icons/md'
import { useState } from 'react'
export const Nav = () => {
  let [activeNave,setActiveNave] = useState('#header')
  console.log(activeNave)
  return (

     
    <nav>
     
      <a  href = "/#testemonal" onClick={()=> setActiveNave('#testemonal')} className= {activeNave === "#testemonal" ? 'active' :''}><FcHome id="icons1"/></a>
      <a  href = "/#header" onClick={()=> setActiveNave('#header')} className= {activeNave === "#header" ? 'active' :''}><SiAboutdotme /></a>
      <a  href = "/#services"onClick={()=> setActiveNave('#services')} className= {activeNave === "#services" ? 'active' :''}><FcSelfServiceKiosk /></a>
      <a  href = "/#experience" onClick={()=> setActiveNave('#experience')} className= {activeNave === "#experience" ? 'active' :''} ><MdLibraryBooks /></a>
      {/* <a  href = "/#testemonal" onClick={()=> setActiveNave('#testemonal')} className= {activeNave === "#testemonal" ? 'active' :''}></a> */}
      <a href ="/#contact" onClick={()=> setActiveNave('#contact')} className= {activeNave === "#contact" ? 'active' :''}><MdContactPhone /></a>
      {/* <a href ="/#portif" onClick={()=> setActiveNave('#portifolio')} className= {activeNave === "#portifolio" ? 'active' :''}><MdFolderSpecial /></a> */}
      
    </nav>
  )
  console.log(activeNave)
}
